function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgAud = function SvgAud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256C0,256.06,256,0.029,256,0 C397.384,0,512,114.616,512,256z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,0c-0.014,0-0.029,0.001-0.043,0.001L256,0L256,0z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M255.315,256H256c0-0.232,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,133.566c0-45.045,0-74.562,0-133.565h-0.043C114.592,0.024,0,114.629,0,256h133.565v-75.212 L208.777,256h46.539c0.229-0.228,0.457-0.456,0.685-0.685c0-17.247,0-32.636,0-46.536l-75.213-75.213H256z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M129.515,33.391C89.476,56.19,56.19,89.476,33.391,129.515V256h66.783V100.175v-0.001H256 c0-21.063,0-41.129,0-66.783H129.515z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,224.519l-90.953-90.952h-31.481c0-0.001,0,0,0,0L255.999,256H256 C256,256,256,234.295,256,224.519z"
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "154.395,300.522 168.445,329.9 200.172,322.567 185.964,351.869 211.478,372.102  179.711,379.262 179.8,411.826 154.395,391.453 128.991,411.826 129.08,379.262 97.312,372.102 122.827,351.869 108.617,322.567  140.346,329.9  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "383.284,356.174 390.309,370.863 406.173,367.196 399.068,381.847 411.826,391.964  395.942,395.544 395.986,411.826 383.284,401.639 370.582,411.826 370.626,395.544 354.743,391.964 367.5,381.847 360.396,367.196  376.259,370.863  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "317.933,200.348 324.957,215.038 340.821,211.37 333.717,226.021 346.474,236.138  330.591,239.718 330.634,256 317.933,245.813 305.231,256 305.274,239.718 289.391,236.138 302.148,226.021 295.044,211.37  310.908,215.038  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "383.284,111.304 390.309,125.994 406.173,122.327 399.069,136.978 411.825,147.094  395.942,150.675 395.986,166.957 383.284,156.77 370.582,166.957 370.626,150.675 354.743,147.094 367.499,136.978  360.396,122.327 376.259,125.994  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "440.368,178.087 447.392,192.777 463.256,189.109 456.152,203.76 468.909,213.877  453.025,217.458 453.069,233.739 440.368,223.553 427.666,233.739 427.709,217.458 411.826,213.877 424.583,203.76  417.479,189.109 433.342,192.777  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "399.55,256 405.075,273.006 422.957,273.006 408.49,283.517 414.017,300.522  399.55,290.012 385.084,300.522 390.609,283.517 376.143,273.006 394.024,273.006  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AUD.cab2eac6.svg";
export { ForwardRef as ReactComponent };